import { Box, Container, Flex, Text, Divider, SimpleGrid, Input, FormControl, FormLabel, Select, ButtonGroup, Button, FormErrorMessage } from "@chakra-ui/react";
import { ReactElement, useEffect, useState } from "react";
import LoadingScreen from "components/loading-screen";
import Layout from "scenes/layouts";
import { useNavigate, useParams } from "react-router-dom";
import { Field, Formik } from "formik";
import LogosNotification from "utils/notification-utils";
import VoucherService from "../../services/vouchers/voucher-service";
import { SingleDatepicker } from "chakra-dayzed-datepicker";
import ProgramService from "../../services/programs/program-service";
import ShortenLinkService from "../../services/shorten/shortenlink-service";

const formInitialValue = {
    name: '',
    longUrl: '',
    backHalf: '',
    isHaveUtm: false,
    utmSource: '',
    utmMedium: '',
    utmCampaign: '',
    isHaveVoucher: false,
    voucherCode: ''
};

const NewShortUrl = (): ReactElement => {
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState<boolean>(false);
    const [isSaving, setSaving] = useState<boolean>(false);
    const [formValue, setFormValue] = useState<any>(formInitialValue);

    const handleFormSubmit = (values: any) => {
        setSaving(true);
        try {
            ShortenLinkService.Create(
                values.name,
                values.longUrl,
                values.backHalf,
                values.isHaveUtm,
                values.utmSource,
                values.utmMedium,
                values.utmCampaign,
                values.isHaveVoucher,
                values.voucherCode
            ).then((res: any) => {
                LogosNotification.Success("Short Url berhasil dibuat.");
                navigate(`/shorturls/${res.result.id}`);
            }).catch((res) => {
            }).finally(() => {
                setSaving(false);
            });
        } catch (error: any) {
            LogosNotification.Error("Error - " + error.message);
            setSaving(false);
        }
    };

    if (isLoading)
        return <LoadingScreen />;

    return (
        <Layout>
            <Container maxWidth={"8xl"} pt={10}>
                <Box>
                    <Flex>
                        <Text fontSize={'3xl'} fontWeight={"bold"}>Buat Url Baru</Text>
                    </Flex>
                    <Formik initialValues={formValue} onSubmit={handleFormSubmit}>
                        {
                            ({ handleSubmit, errors, touched, values, setFieldValue }) => (
                                <form onSubmit={handleSubmit} noValidate={true}>
                                    <Box rounded={'lg'} fontSize={'sm'} border={'1px solid'} borderColor={'blackAlpha.400'}>

                                        <Box px={8} pt={4}>
                                            <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                <FormControl isRequired isInvalid={!!(errors.name && touched.name)}>
                                                    <FormLabel htmlFor='name'>Nama</FormLabel>
                                                    <Field
                                                        as={Input}
                                                        id='name'
                                                        placeholder='Nama Url'
                                                        name={'name'}
                                                        validate={(value: any) => {
                                                            let error;
                                                            if (value.length <= 0) {
                                                                error = "Nama Url wajib diisi."
                                                            }
                                                            return error;
                                                        }}
                                                    />
                                                    <FormErrorMessage>{errors.name}</FormErrorMessage>
                                                </FormControl>
                                                <FormControl>
                                                </FormControl>
                                            </SimpleGrid>
                                        </Box>

                                        <Box px={8} py={4}>
                                            <SimpleGrid columns={{ base: 1 }} gap={12}>
                                                <FormControl isRequired isInvalid={!!(errors.longUrl && touched.longUrl)}>
                                                    <FormLabel htmlFor='voucherCode'>Url Panjang (Destinasi)</FormLabel>
                                                    <Field
                                                        as={Input}
                                                        id='longUrl'
                                                        placeholder='https://example.com/my-long-url'
                                                        name={'longUrl'}
                                                        validate={(value: any) => {
                                                            let error;
                                                            if (value.length <= 0) {
                                                                error = "Long Url wajib diisi."
                                                            }
                                                            return error;
                                                        }}
                                                    />
                                                    <FormErrorMessage>{errors.longUrl}</FormErrorMessage>
                                                </FormControl>
                                            </SimpleGrid>
                                        </Box>

                                        <Box px={8} mb={1}>
                                            <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                <FormControl isRequired isInvalid={!!(errors.backHalf && touched.backHalf)}>
                                                    <FormLabel htmlFor='voucherCode'>Custom back-half</FormLabel>
                                                    <Field
                                                        as={Input}
                                                        id='backHalf'
                                                        placeholder=''
                                                        name={'backHalf'}
                                                        validate={(value: any) => {
                                                            let error;
                                                            if (value.length <= 0) {
                                                                error = "Back Half wajib diisi."
                                                            }
                                                            return error;
                                                        }}
                                                    />
                                                    <FormErrorMessage>{errors.backHalf}</FormErrorMessage>
                                                </FormControl>
                                                <FormControl></FormControl>
                                            </SimpleGrid>
                                        </Box>

                                        <Divider mt={4} />


                                        <Box px={8} pt={4} mb={1}>
                                            <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                <Box>
                                                    <FormControl isRequired isInvalid={!!(errors.isHaveUtm && touched.isHaveUtm)}>
                                                        <FormLabel htmlFor='isCanExpire'>Add UTMs to track web traffic in analytics tools?</FormLabel>
                                                        <Field
                                                            type="checkbox"
                                                            id='isHaveUtm'
                                                            name={'isHaveUtm'}
                                                            checked={values.isHaveUtm}
                                                            style={{ width: '22px', height: '22px' }}
                                                        >
                                                        </Field>
                                                        <FormErrorMessage>{errors.isHaveUtm}</FormErrorMessage>
                                                    </FormControl>
                                                </Box>
                                                <FormControl></FormControl>
                                            </SimpleGrid>
                                        </Box>

                                        {
                                            values.isHaveUtm &&
                                            <Box px={8} mb={1}>
                                                <SimpleGrid columns={{ base: 1, md: 3 }} gap={12}>
                                                    <FormControl isRequired isInvalid={!!(errors.utmSource && touched.utmSource)}>
                                                        <FormLabel htmlFor='voucherCode'>Source</FormLabel>
                                                        <Field
                                                            as={Input}
                                                            id='utmSource'
                                                            placeholder=''
                                                            name={'utmSource'}
                                                            validate={(value: any) => {
                                                                let error;
                                                                if (value.length <= 0) {
                                                                    error = "Utm Source wajib diisi."
                                                                }
                                                                return error;
                                                            }}
                                                        />
                                                        <FormErrorMessage>{errors.utmSource}</FormErrorMessage>
                                                    </FormControl>

                                                    <FormControl isRequired isInvalid={!!(errors.utmMedium && touched.utmMedium)}>
                                                        <FormLabel htmlFor='voucherCode'>Medium</FormLabel>
                                                        <Field
                                                            as={Input}
                                                            id='utmMedium'
                                                            placeholder=''
                                                            name={'utmMedium'}
                                                            validate={(value: any) => {
                                                                let error;
                                                                if (value.length <= 0) {
                                                                    error = "Utm Medium wajib diisi."
                                                                }
                                                                return error;
                                                            }}
                                                        />
                                                        <FormErrorMessage>{errors.utmMedium}</FormErrorMessage>
                                                    </FormControl>

                                                    <FormControl isRequired isInvalid={!!(errors.utmCampaign && touched.utmCampaign)}>
                                                        <FormLabel htmlFor='voucherCode'>Campaign</FormLabel>
                                                        <Field
                                                            as={Input}
                                                            id='utmCampaign'
                                                            placeholder=''
                                                            name={'utmCampaign'}
                                                            validate={(value: any) => {
                                                                let error;
                                                                if (value.length <= 0) {
                                                                    error = "Utm Campaign wajib diisi."
                                                                }
                                                                return error;
                                                            }}
                                                        />
                                                        <FormErrorMessage>{errors.utmCampaign}</FormErrorMessage>
                                                    </FormControl>
                                                </SimpleGrid>
                                            </Box>
                                        }



                                        <Divider mt={4} />


                                        <Box px={8} pt={4} mb={1}>
                                            <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                <Box>
                                                    <FormControl isRequired isInvalid={!!(errors.isHaveVoucher && touched.isHaveVoucher)}>
                                                        <FormLabel htmlFor='isCanExpire'>Voucher?</FormLabel>
                                                        <Field
                                                            type="checkbox"
                                                            id='isHaveVoucher'
                                                            name={'isHaveVoucher'}
                                                            checked={values.isHaveVoucher}
                                                            style={{ width: '22px', height: '22px' }}
                                                        >
                                                        </Field>
                                                        <FormErrorMessage>{errors.isHaveVoucher}</FormErrorMessage>
                                                    </FormControl>
                                                </Box>
                                                {
                                                    values.isHaveVoucher &&
                                                    <FormControl isRequired isInvalid={!!(errors.voucherCode && touched.voucherCode)}>
                                                        <FormLabel htmlFor='voucherCode'>Kode Voucher</FormLabel>
                                                        <Field
                                                            as={Input}
                                                            id='voucherCode'
                                                            placeholder=''
                                                            name={'voucherCode'}
                                                            validate={(value: any) => {
                                                                let error;
                                                                if (value.length <= 0) {
                                                                    error = "Kode Voucher wajib diisi."
                                                                }
                                                                return error;
                                                            }}
                                                        />
                                                        <FormErrorMessage>{errors.voucherCode}</FormErrorMessage>
                                                    </FormControl>
                                                }
                                            </SimpleGrid>
                                        </Box>

                                        <Divider mt={4} />
                                        <Box px={8} py={8}>
                                            <ButtonGroup gap={2}>
                                                <Button type={'submit'} isLoading={isSaving}>Simpan</Button>
                                                <Button variant={'outline'} onClick={() => { navigate('/vouchers') }}>Kembali</Button>
                                            </ButtonGroup>
                                        </Box>
                                    </Box>
                                </form>
                            )
                        }
                    </Formik>
                </Box>
            </Container>
        </Layout >
    );
};

export default NewShortUrl;